import { toast } from '@/ui/toast';
import { extractApiErrorMessageFromUnknown } from '@/shared/errors/api-error';

type NamedGroup = {
    id: string;
    name: string;
};

export type GroupMergeSelection = {
    groupIds: string[];
    defaultGroupName: string;
};

export const extractApiErrorMessage = (error: unknown): string | null => extractApiErrorMessageFromUnknown(error);

export const normalizeMergedGroupNameDraft = (groupNameDraft: string): string | null => {
    const normalizedGroupName = groupNameDraft.trim();
    if (!normalizedGroupName) {
        toast.warning('Название группы не может быть пустым');
        return null;
    }

    return normalizedGroupName;
};

export const prepareGroupMergeSelection = (
    pickedGroupIds: string[],
    groups: NamedGroup[],
): GroupMergeSelection | null => {
    const groupIds = [...new Set(pickedGroupIds)];
    if (groupIds.length < 2) {
        return null;
    }

    const firstSelectedGroup = groups.find((group) => group.id === groupIds[0]);

    return {
        groupIds,
        defaultGroupName: firstSelectedGroup?.name || '',
    };
};
